<template>
  <div v-if="horizontal" style="display: inline">
    <selector id="selector-category-1st"
              horizontal
              :spanSetting="spanSetting"
              :value="String(category1st)"
              :size="size"
              @change="changeCategory1st(Number($event)); $emit('change1st', Number($event))">
      <el-option v-for="categoryItem in categories1st"
                :key="categoryItem.id"
                :label="categoryItem.name"
                :value="String(categoryItem.id)"
                :id="'selector-category-1st-option-' + categoryItem.id"
                >
      </el-option>
    </selector>
    <selector id="selector-category-2nd"
              horizontal
              :spanSetting="spanSetting"
              :value="String(category2nd)"
              :size="size"
              @change="changeCategory2nd(Number($event)); $emit('change2nd', Number($event))">
      <el-option v-for="categoryItem in categories2nd"
                :key="categoryItem.id"
                :label="categoryItem.name"
                :value="String(categoryItem.id)"
                :id="'selector-category-2nd-option-' + categoryItem.id"
                >
      </el-option>
    </selector>
    <selector id="selector-category-3rd"
              horizontal
              :spanSetting="spanSetting"
              :value="String(category3rd)"
              :size="size"
              @change="$emit('change3rd', Number($event))">
      <el-option v-for="categoryItem in categories3rd"
                :key="categoryItem.id"
                :label="categoryItem.name"
                :value="String(categoryItem.id)"
                :id="'selector-category-3rd-option-' + categoryItem.id"
                >
      </el-option>
    </selector>
  </div>
  <el-row v-else>
    <selector
      id="selector-category-1st"
      :label="'カテゴリ'"
      :spanTitle="spanTitle"
      :spanSetting="spanSetting"
      required
      :value="String(category1st)"
      :size="size"
      @change="changeCategory1st(Number($event)); $emit('change1st', Number($event))">
    >
      <el-option v-for="categoryItem in categories1st"
                :key="categoryItem.id"
                :label="categoryItem.name"
                :value="String(categoryItem.id)"
                :id="'selector-category-1st-option-' + categoryItem.id"
                >
      </el-option>
    </selector>
    <selector id="selector-category-2nd"
              :label="''"
              :spanTitle="spanTitle"
              :spanSetting="spanSetting"
              :value="String(category2nd)"
              :size="size"
              @change="changeCategory2nd(Number($event)); $emit('change2nd', Number($event))">
      <el-option v-for="categoryItem in categories2nd"
                :key="categoryItem.id"
                :label="categoryItem.name"
                :value="String(categoryItem.id)"
                :id="'selector-category-2nd-option-' + categoryItem.id"
                >
      </el-option>
    </selector>
    <selector id="selector-category-3rd"
              v-bind:label="''"
              v-bind:spanTitle="spanTitle"
              v-bind:spanSetting="spanSetting"
              :value="String(category3rd)"
              :size="size"
              @change="$emit('change3rd', Number($event))">
      <el-option v-for="categoryItem in categories3rd"
                :key="categoryItem.id"
                :label="categoryItem.name"
                :value="String(categoryItem.id)"
                :id="'selector-category-3rd-option-' + categoryItem.id"
                >
      </el-option>
    </selector>
  </el-row>
</template>

<script>
import Selector from '@/components/Selector.vue'
import api from '@/http/api.js'
import Constants from './Constants'

export default {
  name: 'CategorySelector',
  components: {
    selector: Selector
  },
  props: {
    category1st: {
      type: Number
    },
    category2nd: {
      type: Number
    },
    category3rd: {
      type: Number
    },
    spanTitle: {
      type: Number,
      default: Constants.SPAN_TITLE
    },
    spanSetting: {
      type: Number,
      default: Constants.SPAN_INPUT
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      categories1st: [{ id: 0, name: '指定なし' }],
      categories2nd: [{ id: 0, name: '指定なし' }],
      categories3rd: [{ id: 0, name: '指定なし' }]
    }
  },
  watch: {
    category1st: function (newValue) {
      this.changeCategory1st(newValue)
    },
    category2nd: function (newValue) {
      this.changeCategory2nd(newValue)
    }
  },
  methods: {
    changeCategory1st: function (id1st) {
      api.category.getSecondCategories(id1st).then(data => {
        this.categories2nd = data
        this.categories2nd.unshift({ id: 0, name: '指定なし' })
      })
    },
    changeCategory2nd: function (id2nd) {
      api.category.getThirdCategories(this.category1st, id2nd).then(data => {
        this.categories3rd = data
        this.categories3rd.unshift({ id: 0, name: '指定なし' })
      })
    }
  },
  mounted: function () {
    api.category.getTopCategories().then(data => {
      this.categories1st = data
      this.categories1st.unshift({ id: 0, name: '指定なし' })
    })
  }
}
</script>

<style scoped>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
}
</style>
